import { FitBounds } from 'react-mapbox-gl/lib/map';
import { atom } from 'recoil';
import { loadPersistedValue, persistOnSet } from '../effects';
import { MapAssetType } from '../../contexts/AggregatesContext/types';
import { MapBounds } from '../../contexts/FilterContext/types';

export const mapBoundsState = atom<MapBounds | null>({
  key: 'mapBoundsState',
  default: null,
});

export const mapSelectBoundsState = atom<MapBounds | null>({
  key: 'mapSelectBoundsState',
  default: null,
});

export const mapLocalBoundsState = atom<FitBounds | undefined>({
  key: 'mapMaintenance.mapLocalBoundsState',
  default: undefined,
  effects: [loadPersistedValue, persistOnSet],
});

export const forceMapReloadState = atom<boolean>({
  key: 'forceMapReloadState',
  default: false,
});

export const cardIdsState = atom<string[]>({
  key: 'cardIdsState',
  default: [],
});

export const selectedItemsState = atom<MapAssetType[]>({
  key: 'selectedItemsState',
  default: [],
});

export const mapCardHeightState = atom<number>({
  key: 'mapCardHeightState',
  default: 0,
});